<template>
  <div class="container mescroll-touch">
    <div class="consult-info">
      <span class="title van-multi-ellipsis--l2">{{ details.Title }}</span>
      <div class="prepose-info">
        <div class="source">
          <div class="source-icon" v-if="details.SourceIcon">
            <img :src="details.SourceIcon" />
          </div>
          <span class="source-title" v-if="details.Source">{{ details.Source }}</span>
        </div>
        <div class="time" v-if="details.DatePublish">{{ details.DatePublish.split('T')[0] }}</div>
      </div>
      <div class="rich_view">
        <div class="rich" v-html="details.Content"></div>
      </div>
    </div>
    <div class="consult-commit">
      <div class="title">评论区</div>
      <div class="general_comment_content" v-if="details.CommentList && details.CommentList.length > 0">
        <div class="comment_item" v-for="(item, index) in details.CommentList" :key="index">
          <div class="includimg" @click="replyToComment(item)">
            <div class="comment_item_new">
              <div class="comment_picture">
                <img :src="item.HeadUrl" />
              </div>
              <div class="comment_box">
                <div class="comment_name">{{ item.UserName }}</div>
                <div class="comment_content">{{ item.Content }}</div>
              </div>
            </div>
            <div class="comment_repic" v-if="item.PicUrl">
              <img :src="item.PicUrl" alt="">
            </div>
          </div>
          <div v-for="(iitem, idx) in item.ReplyCommentList" :key="idx" class="comment_back"
            @click="replyToReply(iitem, item)">
            <div class="notincludimg">
              <div class="comment_picture">
                <img :src="iitem.HeadUrl" />
              </div>
              <div class="comment_box">
                <div class="comment_name">{{ iitem.UserName }}</div>
                <div class="comment_content"><span class="back_small">回复{{ iitem.UpUserName }}：</span>{{ iitem.Content
                }}</div>
              </div>
            </div>
            <div class="comment_repic" v-if="iitem.PicUrl">
              <img :src="iitem.PicUrl" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="general_comment_no_content" v-else>
        <img src="@/assets/images/no_comment.png">
        <p>暂无留言信息</p>
      </div>
    </div>

    <div class="consult-btn1" v-if="showsendpage == 1">
      <div class="consult-input-wrapper">
        <div class="consult-row">
          <div class="consult-input">
            <input ref="commentInput" type="text" :placeholder="replyPlaceholder" v-model="comment" enterkeyhint="send">
          </div>
          <div @click="sendComment" class="sendbtn">发送</div>
        </div>
        <!-- 图片预览区域 - 放在输入框下方 -->
        <!-- v-if="wantupimg == 1" -->
        <div class="upimg" style="margin-top: .35rem;">
          <van-uploader v-model="imgList" :after-read="afterRead" multiple :max-count="1"
            :upload-icon="require('../../assets/images/hsup.png')" />
        </div>
      </div>
    </div>
    <div class="backblack" v-if="showsendpage == 1" @click="opensend()"></div>

    <!-- 底部固定评论栏 -->
    <div class="consult-btn">
      <div class="consult-input-wrapper" @click="opensend()">
        <div class="consult-input">
          <input type="text" :placeholder="replyPlaceholder" v-model="comment" readonly>
          <!-- 上传按钮 -->
          <i class="el-icon-chat-line-square openpic"></i>
        </div>
        <!-- 图片预览区域 - 放在输入框下方 -->
        <!-- v-if="wantupimg == 1" -->
        <!-- <div class="upimg">
          <van-uploader v-model="imgList" :after-read="afterRead" multiple :max-count="1"
            :upload-icon="require('../../assets/images/hsup.png')" />
        </div> -->
      </div>
      <div class="consult-icon" @click="changeLike">
        <img :src="details.IsLike ? require('@/assets/images/like.png') : require('@/assets/images/no_like.png')">
        <span>点赞</span>
      </div>
      <div class="consult-icon" @click="changeFavorite">
        <img
          :src="details.IsCollect ? require('@/assets/images/collect_img.png') : require('@/assets/images/no_collect.png')">
        <span>收藏</span>
      </div>
      <div class="consult-icon" @click="showSharePanel = true">
        <img class="share-icon" src="@/assets/images/share.png">
        <span>分享</span>
      </div>
    </div>

    <!-- 取消回复按钮 -->
    <div class="cancel-reply" v-if="replyTarget" @click="cancelReply">
      <span>回复 {{ replyTarget.UserName }}</span>
      <span class="cancel-text">取消</span>
    </div>

    <SharePanel :show="showSharePanel" @close="closeSharePanel" />
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import SharePanel from '@/components/sharePanel.vue'
export default {
  name: 'InformationDetails',
  data() {
    return {
      details: {},
      commentList: [],
      comment: '',
      showSharePanel: false,
      imgList: [],
      uploadImgUrl: '',
      replyTarget: null,
      replyRootId: '',
      replyType: '',
      wantupimg: 0,
      showsendpage: 0,
    }
  },
  mixins: [mixin],
  components: {
    SharePanel
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    replyPlaceholder() {
      return this.replyTarget ? `回复 ${this.replyTarget.UserName}` : '友善评论，文明发言';
    }
  },
  created() {
    document.title = "华肤荟";
    if (this.code) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.$axios.get(`/api/api/web/content/GetArticleDetail?code=${this.code}`).then(res => {
        this.details = res.Data;
        this.initShare(this.details.Title);
      })
    },
    // 点击评论进行回复
    replyToComment(item) {
      this.replyTarget = item;
      this.replyRootId = item.Id;   // 根评论ID = 当前根评论的Id
      this.replyType = 'root';       // 标记为回复根评论
      this.$nextTick(() => {
        this.$refs.commentInput && this.$refs.commentInput.focus();
      });
    },
    replyToReply(iitem, item) {
      this.replyTarget = iitem;
      this.replyRootId = item.Id;    // 根评论ID = 外层根评论的Id
      this.replyType = 'reply';       // 标记为回复子评论
      this.$nextTick(() => {
        this.$refs.commentInput && this.$refs.commentInput.focus();
      });
    },
    // 取消回复
    cancelReply() {
      this.replyTarget = null;
      this.replyRootId = '';
      this.replyType = '';
    },
    opensend() {
      if (!this.showsendpage) {
        this.showsendpage = 1
      } else {
        this.showsendpage = 0
      }
    },
    sendComment() {
      if (!this.comment.trim() && !this.uploadImgUrl) {
        this.$toast('请输入评论内容');
        return;
      }

      const params = {
        ContentCode: this.code,
        Content: this.comment,
        PicUrl: this.uploadImgUrl,
      };

      if (this.replyTarget) {
        // ========== 情况2：回复根评论 ==========
        if (this.replyType === 'root') {
          params.RootCommentId = this.replyRootId;  // = item.Id
          params.UpCommentId = '';
          params.UpUserName = this.replyTarget.UserName;
          params.UpUserCode = this.replyTarget.UserCode;
        }
        // ========== 情况3：回复"评论的评论" ==========
        else if (this.replyType === 'reply') {
          params.RootCommentId = this.replyRootId;           // = 根评论 item.Id
          params.UpCommentId = this.replyTarget.Id;          // = iitem.Id
          params.UpUserName = this.replyTarget.UserName;   // = iitem.UpUserName
          params.UpUserCode = this.replyTarget.UserCode;   // = iitem.UpUserCode
        }
      } else {
        // ========== 情况1：直接发布评论（根评论）==========
        params.RootCommentId = '';
        params.UpCommentId = '';
        params.UpUserName = '';
        params.UpUserCode = '';
      }

      this.$axios.post('/api/api/web/content/CommentArticle', params).then(res => {
        this.comment = '';
        this.imgList = [];
        this.uploadImgUrl = '';
        this.replyTarget = null;
        this.replyRootId = '';
        this.replyType = '';
        this.$refs.commentInput.blur();
        this.$toast.success('提交成功，请等待审核');
        this.wantupimg = 0;
        this.showsendpage = 0;
        this.getDetails();
      });
    },
    changeLike() {
      this.$axios.get(`/api/api/web/content/ArticleLike?articleCode=${this.code}`).then(res => {
        this.getDetails();
      })
    },
    changeFavorite() {
      this.$axios.get(`/api/api/web/content/ArticleCollect?articleCode=${this.code}`).then(res => {
        this.getDetails();
      })
    },
    closeSharePanel() {
      this.showSharePanel = false;
    },
    afterRead(file) {
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/api/web/ImgFile/UploadImg", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.RetCode == 10000) {
            this.uploadImgUrl = res.Data.Url;
            this.$toast.success("图片上传成功");
          } else {
            this.$toast.fail(res.Msg || "图片上传失败");
            this.imgList = [];
          }
        });
    },
    uppicclick() {
      if (this.wantupimg == 0) {
        this.wantupimg = 1
      } else {
        this.wantupimg = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  padding-bottom: 80px;
  box-sizing: border-box;

  .consult-info {
    background-color: #FFFFFF;
    padding: 10px;
    box-sizing: border-box;

    .title {
      color: #0c2941;
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .prepose-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #768FA4;

      .source {
        display: flex;
        align-items: center;

        .source-icon {
          width: 22px;
          height: 22px;
          background: #FFFFFF;
          border-radius: 50%;
          overflow: hidden;
          border: 1px solid #E8F0FC;
          box-sizing: border-box;
          margin-right: 5px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .rich_view {
      margin-top: 15px;

      .rich {
        /deep/ .ksx-ue-question-video-box {
          width: 100% !important;
        }

        video {
          width: 100%;
        }
      }
    }
  }

  /deep/ .rich>p>img {
    width: 100%;
  }

  .consult-commit {
    border-top: 8px solid #f8fafc;
    background-color: #FFFFFF;
    padding: 10px;

    .title {
      color: #0c2941;
      font-size: 14px;
      font-weight: 500;
    }

    .general_comment_content {
      padding: 10px 0 20px;
    }

    .general_comment_no_content {
      padding: 40px 0;
      text-align: center;

      img {
        display: block;
        width: 140px;
        margin: 0 auto 20px;
      }

      p {
        font-size: 14px;
        color: #435361;
      }
    }
  }
}

// 评论项样式
.comment_item {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border-bottom: 1px solid #e5e5e5;

  .includimg,
  .comment_back {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:active {
      background-color: #f5f5f5;
    }
  }
}

.comment_item_new {
  display: flex;
}

.comment_picture {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.comment_box {
  flex: 1;
  margin-left: 10px;
  padding-bottom: 12px;
}

.comment_name {
  font-size: 14px;
  color: #435361;
  margin: 4px 0;
}

.comment_content {
  color: #0C2941;
  font-size: 14px;
  line-height: 1.5;
}

.comment_back {
  padding-top: 10px;
  border-top: 1px solid #e5e5e5;
  width: 89%;
  margin-left: 11%;
}

.back_small {
  color: #8e8e8e;
  font-size: 13px;
}

.comment_repic {
  display: block;
  width: 60%;
  height: auto;
  padding-bottom: 10px;
  margin-left: 45px;

  img {
    display: block;
    width: 100%;
    border-radius: 4px;
  }
}

.notincludimg {
  display: flex;
}

// 取消回复提示条
.cancel-reply {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 50px;
  height: 50px;
  background: linear-gradient(90deg, #e3f2fd, #fff3e0);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  font-size: 13px;
  color: #1976d2;
  z-index: 99;
  border-top: 1px solid #e5e5e5;

  .cancel-text {
    color: #f44336;
    font-size: 12px;
    padding: 2px 8px;
    border: 1px solid #f44336;
    border-radius: 10px;
  }
}

// 底部固定栏
.consult-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 50px;
  max-height: 140px; // 限制最大高度，防止图片预览占太多空间
  background-color: #FFFFFF;
  border-top: 1px solid #e5e5e5;
  padding: 6px 10px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-wrap: wrap;
  overflow-y: auto;
  z-index: 100;

  .consult-input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .consult-input {
    flex: 1;
    background-color: #f6f8f9;
    border-radius: 6px;
    overflow: hidden;
    padding: 6px 40px 6px 10px;
    position: relative;
    display: flex;
    align-items: center;
    min-height: 36px;
    box-sizing: border-box;

    input {
      width: 100%;
      height: 36px;
      border: none;
      background-color: transparent;
      font-size: 14px;
      outline: none;
    }

    .upimg {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  // 图片预览区域 - 放在输入框下方，紧凑排列
  .img-preview {
    margin-top: 6px;
    width: 60px;
    height: 60px;
    position: relative;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
      display: block;
    }

    .close-preview {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 18px;
      height: 18px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      text-align: center;
      line-height: 18px;
      border-radius: 50%;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .consult-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin-left: 10px;
    flex-shrink: 0;
    margin-top: 2px;

    img {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }

    .share-icon {
      width: 20px;
      height: 20px;
    }

    span {
      font-size: 11px;
      color: #0c2941;
      margin-top: 2px;
    }
  }
}

.openpic {
  float: right;
  display: block;
  position: absolute;
  right: 5.5%;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.5rem;
}

.consult-btn1 {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 50px;
  max-height: 180px; // 限制最大高度，防止图片预览占太多空间
  background-color: #FFFFFF;
  border-top: 1px solid #e5e5e5;
  padding: 6px 10px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-wrap: wrap;
  overflow-y: auto;
  z-index: 105;

  .consult-input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .consult-input {
    background-color: #f6f8f9;
    border-radius: 0.16rem;
    overflow: hidden;
    padding: 0.16rem 0.266667rem 0.16rem 0.266667rem;
    position: relative;
    display: flex;
    align-items: center;
    min-height: 0.96rem;
    box-sizing: border-box;
    width: 80%;

    input {
      width: 100%;
      height: 36px;
      border: none;
      background-color: transparent;
      font-size: 14px;
      outline: none;
    }

    .upimg {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  // 图片预览区域 - 放在输入框下方，紧凑排列
  .img-preview {
    margin-top: 6px;
    width: 60px;
    height: 60px;
    position: relative;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
      display: block;
    }

    .close-preview {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 18px;
      height: 18px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      text-align: center;
      line-height: 18px;
      border-radius: 50%;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .consult-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin-left: 10px;
    flex-shrink: 0;
    margin-top: 2px;

    img {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }

    .share-icon {
      width: 20px;
      height: 20px;
    }

    span {
      font-size: 11px;
      color: #0c2941;
      margin-top: 2px;
    }
  }
}

.backblack {
  background: rgba(0, 0, 0, 0.8);
  position: absolute !important;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
}

.consult-row {
  display: flex;
  flex-direction: row;
}

.sendbtn {
  background: #b92d3d;
  width: 18%;
  margin-left: 2%;
  text-align: center;
  color: #fff;
  font-size: .4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
</style>